import { isRawErrorResponse, ResponseError, ServerError, toErrorResponse } from './Error';
export var JSONTYPE = 'application/json';
export var DEFAULT_BAAS_SERVER_URL = 'https://realm.mongodb.com';
var version = 'unknown';
if (typeof VERSION !== 'undefined') {
    version = VERSION;
}
export var SDK_VERSION = version;
export var checkStatus = function (response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    if (response.headers.get('Content-Type') === JSONTYPE) {
        return response.json().then(function (json) {
            if (!isRawErrorResponse(json)) {
                return Promise.reject(json);
            }
            var serverErr = new ServerError(json.error, json.error_code);
            serverErr.response = response;
            serverErr.json = toErrorResponse(json);
            return Promise.reject(serverErr);
        });
    }
    var error = new ResponseError(response.statusText);
    error.response = response;
    return Promise.reject(error);
};
export var makeFetchArgs = function (method, options) {
    var _a;
    var headers = (_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {};
    if (!headers.Accept) {
        headers.Accept = JSONTYPE;
    }
    if (!(options === null || options === void 0 ? void 0 : options.multipart) && !headers['Content-Type']) {
        headers['Content-Type'] = JSONTYPE;
    }
    return {
        body: options === null || options === void 0 ? void 0 : options.body,
        credentials: options === null || options === void 0 ? void 0 : options.credentials,
        headers: headers,
        method: method,
        mode: 'cors',
    };
};
//# sourceMappingURL=Common.js.map